import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import SubstanceMetaItemComponent from '@Components/Results/substances/substance-meta-item.component';
import htmlStripsService from '@Services/HtmlStripsService';
import { SUBSTANCE_DETAILS_TOOLTIPS } from '@Constants/ElementConstants';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import join from 'lodash/join';
import CasNumberContainer, { isCasNumberAllowed } from '@Containers/CasNumber';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';

export default class SubstanceHeaderComponent extends React.PureComponent {
  render() {
    const {
      substance: { index, sourceUrl, details, molImage },
      database: { id: databaseId, name: databaseName, isCIDatabase },
      onToggle,
    } = this.props;
    const resultName = get(this.props, 'metadata.resultName');
    const chemicalNames = details && details.chemicalNames ? details.chemicalNames : [];
    const title = htmlStripsService.getTitleWithoutHtml(join(chemicalNames), 'full');
    const name = isArray(chemicalNames) && chemicalNames.length > 0 ? chemicalNames[0] : `${databaseName} ID: ${details?.id || ''}`;
    const mapped = SUBSTANCE_DETAILS_TOOLTIPS[databaseId];
    const tooltip = get(mapped, 'id') || `${databaseName} ID`;

    return (
      <header className="substance__header" aria-controls={`substances-${index}`}>
        <h2 className="substance__title typography-small keyword">
          {/* eslint-disable-next-line no-script-url */}
          <InnerHTML
            mode="escapeCustom"
            tag="a"
            href="null"
            title={title}
            onClick={(e) => {
              e.preventDefault();
              onToggle();
            }}
            html={name}
          />
        </h2>
        <div className="substance__meta">
          {details && details.formula && <SubstanceMetaItemComponent tooltip="Linear Structure Formula" content={details.linearFormula} />}
          {details && details.weight && <SubstanceMetaItemComponent tooltip="Molecular Weight" content={details.weight} />}
          {details && details.id && !isCIDatabase && (
            <SubstanceMetaItemComponent link={{ sourceUrl }} tooltip={tooltip} content={details.id} />
          )}
          {!Auth.isFeatureEnabled(FEATURES.disableCasNumberCta) ? (
            <CasNumberContainer
              className="substance__meta__item"
              casRegistryNumbers={details?.casRegistryNumbers}
              substanceId={details?.id}
              databaseId={databaseId}
              resultName={resultName}
              name={details?.chemicalNames && details?.chemicalNames[0]}
              structure={molImage && molImage.structure}
              inChiKey={details?.inChiKey}
              withCta
            />
          ) : (
            isCasNumberAllowed(databaseId) &&
            !isEmpty(details?.casRegistryNumbers) && (
              <SubstanceMetaItemComponent
                tooltip="CAS Number"
                content={isArray(details?.casRegistryNumbers) ? details.casRegistryNumbers.join(', ') : details?.casRegistryNumbers}
              />
            )
          )}
        </div>
      </header>
    );
  }
}

SubstanceHeaderComponent.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};
